import { initializePostHog } from "@/lib/analytics/track";

initializePostHog();
